"use client";

import { useTranslation } from "react-i18next";
import { Toaster as Sonner } from "sonner";

import type { ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { t } = useTranslation();

  return (
    <Sonner
      theme="light"
      containerAriaLabel={t("common.notifications")}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
